import { useEffect } from "react";
import { Button, Layout, Tooltip } from "antd";
import { GeneralStore } from "../stores";
import { useNavigate } from "react-router-dom";
import { getSidebarLabelByValue } from "../helper";
import { SidebarItems } from "./constants/SidebarData";
import { ClaimController, Logo, ProfileDropdown } from "../sharedComponents";
import { LeftOutlined, MenuOutlined } from "@ant-design/icons";
import { useInnerWidth } from "../hooks";

const { Header } = Layout;

export const Title = () => {
  const navigate = useNavigate();
  const sidebarData = SidebarItems();
  const innerWidth = useInnerWidth();
  const currentPath = window.location.pathname;
  const {
    pageTitle,
    setPageTitle,
    setMobileSidebarOpen,
    contentPadding,
    setContentPadding,
  } = GeneralStore();

  useEffect(() => {
    setPageTitle(getSidebarLabelByValue(currentPath, sidebarData));
    if (!contentPadding) setContentPadding(true);
  }, [currentPath]);

  return (
    <Header className=" m-2 bg-white rounded-lg flex items-center justify-between border border-gray-200">
      <div className="flex items-center gap-1">
        <Button
          size={innerWidth < 640 ? "small" : "middle"}
          type="text"
          onClick={() => navigate(-1)}
          icon={<LeftOutlined />}
        />
        <Tooltip title={pageTitle}>
          <h1 className="text-[14px] sm:text-[18px] text-nowrap md:text-[24px] font-semibold z-10 select-none cursor-default">
            {innerWidth < 640
              ? pageTitle.length > 11
                ? pageTitle.slice(0, 15) + "..."
                : pageTitle
              : pageTitle.length > 30
              ? pageTitle.slice(0, 34) + "..."
              : pageTitle}
          </h1>
        </Tooltip>
      </div>

      <div className=" md:hidden  flex items-center  ">
        <Button
          className="md:hidden"
          type="text"
          size="large"
          icon={<MenuOutlined />}
          onClick={() => setMobileSidebarOpen(true)}
        />
        <Logo className="h-12  " />
      </div>
      <div className="hidden md:flex items-center gap-1">
        <ProfileDropdown />
      </div>
    </Header>
  );
};
